import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import CheckoutShell from "./CheckoutShell";
import { useCommerce } from "@/contexts/CommerceContext";


const safeReturnPath = (value) => (
  value?.startsWith("/") && !value.startsWith("//") ? value : "/"
);

const AccountContinuePage = () => {
  const [error, setError] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshAccount } = useCommerce();

  useEffect(() => {
    let active = true;
    let timer;
    refreshAccount()
      .then((status) => {
        if (!active) return;
        if (!status.fivem_connected) {
          setError("FiveM login could not be confirmed. Please try again.");
          return;
        }
        toast.success(`FiveM connected${status.fivem_username ? ` as ${status.fivem_username}` : ""}.`);
        timer = window.setTimeout(() => {
          navigate(safeReturnPath(searchParams.get("return")), { replace: true });
        }, 500);
      })
      .catch(() => {
        if (active) setError("FiveM login could not be confirmed. Please try again.");
      });
    return () => {
      active = false;
      if (timer) window.clearTimeout(timer);
    };
  }, [navigate, refreshAccount, searchParams]);

  return (
    <CheckoutShell title={error ? "Login paused" : "FiveM connected"} eyebrow="Account connection">
      {error ? (
        <p className="text-red-300">{error}</p>
      ) : (
        <div className="text-center">
          <CheckCircle2 className="mx-auto mb-4 h-10 w-10 text-emerald-400" />
          <p>Returning you to the page you were viewing…</p>
        </div>
      )}
    </CheckoutShell>
  );
};

export default AccountContinuePage;
